(() => {
  if (customElements.get('skelody-purchase')) return;
  customElements.define('skelody-purchase', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const form = this.querySelector('form');
      const button = form.querySelector('button');
      const status = form.querySelector('[data-purchase-status]');
      const cart = form.querySelector('[data-purchase-cart]');
      const quantity = form.querySelector('[data-quantity-1-to-99]');
      const quantityError = form.querySelector('[data-quantity-error]');
      const validateQuantity = (onSubmit = false) => {
        if (!quantity) return true;
        const valid = /^(?:[1-9]|[1-9][0-9])$/.test(quantity.value);
        const showError = !valid && (onSubmit || quantity.value !== '');
        quantity.setCustomValidity(showError ? 'Enter a quantity from 1 to 99.' : '');
        if (showError) quantity.setAttribute('aria-invalid', 'true');
        else quantity.removeAttribute('aria-invalid');
        quantityError.hidden = !showError;
        return valid;
      };
      if (quantity) quantity.addEventListener('input', () => validateQuantity());
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (this.pending || button.disabled) return;
        if (!validateQuantity(true)) { quantity.focus(); quantity.reportValidity(); return; }
        if (!form.reportValidity()) return;
        this.pending = true;
        button.disabled = true;
        form.setAttribute('aria-busy', 'true');
        status.textContent = 'Adding to cart…';
        try {
          const response = await fetch(form.action + '.js', {method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});
          const data = await response.json();
          if (!response.ok) throw new Error(data.description || 'Unable to add this item. Please check your cart before trying again.');
          status.textContent = 'Added to cart.';
          cart.dataset.purchaseSuccess = 'true';
          cart.hidden = false;
          cart.focus();
        } catch (error) {
          delete cart.dataset.purchaseSuccess;
          status.textContent = error.message || 'Please check your cart before trying again.';
          cart.hidden = false;
        } finally {
          this.pending = false;
          button.disabled = false;
          form.removeAttribute('aria-busy');
        }
      });
    }
  });
})();
